import axios from 'axios';

const hostname = window.location.hostname;

const environment = {
  local: {
    apiGeneral: process.env.REACT_APP_URL_BASE_LOCAL as string,
    apiHub: process.env.REACT_APP_URL_HUB_LOCAL as string,
  },
  production: {
    apiGeneral: process.env.REACT_APP_URL_BASE as string,
    apiHub: process.env.REACT_APP_URL_HUB as string,
  },
  homologacao: {
    apiGeneral: process.env.REACT_APP_URL_BASE_HML as string,
    apiHub: process.env.REACT_APP_URL_HUB_HML as string,
  },
};

const getEnvironment = () => {
  if (hostname === 'localhost') {
    return environment.local;
  }

  if (hostname === 'dow.webcol.systems') {
    return environment.production;
  }

  if (hostname === 'hml-dow.webcol.systems') {
    return environment.homologacao;
  }

  return environment.homologacao;
};

const baseURL = getEnvironment();

export const dashboardUrl = process.env.REACT_APP_URL_DASHBOARD as string;

export const apiDashboard = axios.create({
  baseURL: dashboardUrl,
  headers: {},
  withCredentials: true,
});

export const apiGeneral = axios.create({
  baseURL: baseURL.apiGeneral,
  headers: {},
  //   withCredentials: true,
});

export const apiHub = axios.create({
  baseURL: baseURL.apiHub,
});

export const queryBuilder = (payload: Record<string, any>): string => {
  const validObject: Record<string, any> = {};

  for (const [param, value] of Object.entries(payload)) {
    if (value) Object.assign(validObject, { [param]: value });
  }

  const searchParams = new URLSearchParams(validObject).toString();
  return searchParams;
};

export const formDataBuilder = (payload: Record<string, any>): FormData => {
	const formData = new FormData();

	for (const [param, value] of Object.entries(payload)) {
		if (Array.isArray(value)) {
			value.forEach((item: any) => {
				if (item instanceof File) {
					formData.append(param, item, item.name);
				} else if (item) {
					formData.append(param, item);
				}
			});
		} else if (value instanceof File) {
			formData.append(param, value, value.name);
		} else if (value) {
			formData.append(param, value);
		}
	}

	return formData;
};

export const handleApiError = (error: any): Error => {
  return new Error(error?.response?.data?.error?.message || error?.message);
}
